import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import toast from '@/components/toast/index.js'
import * as utils from './common/utils'
import filters from './common/filter.js'
import wxjssdk from 'jweixin-module'
import './common/sdk/report_sdk/report_sdk.js'
import 'amfe-flexible'
import './plugins/video'
import './plugins/vconsole'


Vue.prototype.$wx = wxjssdk

Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.use(toast)
Object.keys(filters).map(v => {
  Vue.filter(v, filters[v])
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
